// The desktop shell's view of a BLE lamp group (DeviceID BLE_WWH_DEVICE_ID).
//
// A browser — and the Wall Panel tablet in Wall Mode — has no way to broadcast
// BLE advertisements, and these lamps listen to nothing else (no ESP, no
// MQTT). So the desktop draws the device's identity and says where to control
// it from, rather than a slider that would publish into the void. Both the
// full screen (DeviceControls) and the room card (DeviceControlCard) use it.

import React from 'react';
import { Box, Card, Typography } from '@mui/material';
import BluetoothIcon from '@mui/icons-material/Bluetooth';
import DeviceShell from '../../components/DeviceShell';

export function BleLampNoticeBody({ device, compact = false }) {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, p: compact ? 1 : 2 }}>
      <BluetoothIcon sx={{ fontSize: compact ? 28 : 40, opacity: 0.8 }} />
      <Box>
        <Typography sx={{ fontWeight: 600 }}>
          {device.DeviceName || device.UniqueNumber}
        </Typography>
        <Typography color="text.secondary" sx={{ fontSize: compact ? 13 : 15 }}>
          BLE lamp group — controlled by the phone&apos;s Bluetooth near the lamps, or from here through the location&apos;s hub (Bluetooth Mesh lamps only).
        </Typography>
      </Box>
    </Box>
  );
}

export default function BleLampNoticeScreen({ device }) {
  return (
    <DeviceShell title={device.DeviceName || device.UniqueNumber}>
      <Card sx={{ bgcolor: 'primary.main', borderRadius: 3 }}>
        <BleLampNoticeBody device={device} />
      </Card>
    </DeviceShell>
  );
}
